import { LANGUAGE_CODES } from '@constants/countryDetails'
import { APP_FEATURES } from '@constants/features'
import type { AppLocales } from '@constants/i18n'
import { arrayIncludes } from '@helpers/arrayIncludes'
import { createBreadcrumbStucturedData } from '@helpers/createBreadcrumbStructureData'

export const createPressReleaseBreadcrumb = (
  websiteUrl: string,
  locale: AppLocales,
  name: string | undefined | null,
  title: string | undefined | null
) => {
  const language = locale.slice(0, 2)

  if (!language || !arrayIncludes(LANGUAGE_CODES, language)) return

  const linkToPressReleases = `${websiteUrl}${APP_FEATURES.PressReleases.initialPrefix[language]}`

  const pressReleaseBreadCrumb = []

  if (name)
    {pressReleaseBreadCrumb.push({
      name,
      link: linkToPressReleases,
    })}

  if (title)
    {pressReleaseBreadCrumb.push({
      name: title,
      link: linkToPressReleases,
    })}

  const breadcrumbStructuredData = createBreadcrumbStucturedData(
    pressReleaseBreadCrumb
  )

  return breadcrumbStructuredData
}
